import { render, staticRenderFns } from "./LandIndex2.vue?vue&type=template&id=6303095c&scoped=true&"
import script from "./LandIndex2.vue?vue&type=script&lang=js&"
export * from "./LandIndex2.vue?vue&type=script&lang=js&"
import style0 from "./LandIndex2.vue?vue&type=style&index=0&id=6303095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303095c",
  null
  
)

export default component.exports